document.addEventListener('DOMContentLoaded', () => {
  gsap.registerPlugin(ScrollTrigger);
  const isMobile = window.innerWidth < 768;

  
  if(!isMobile){
    const lenis = new Lenis({
      smooth: true,
      direction: 'vertical',
      syncTouch: true,
      syncTouchLerp: 0.1,
      touchMultiplier: 1.2,
      lerp: 0.08,
      normalizeWheel: true,
    });

    lenis.on('scroll', ScrollTrigger.update);

    gsap.ticker.add((time) => {
      lenis.raf(time * 1000);
    });

    gsap.ticker.lagSmoothing(0);

    ScrollTrigger.addEventListener('refresh', () => lenis.raf(performance.now()));
  }

  ScrollTrigger.refresh();

  window.addEventListener('resize', () => {
    ScrollTrigger.refresh();
  });
});